import { render, staticRenderFns } from "./OperationMenu.vue?vue&type=template&id=06c03b5d&scoped=true&"
import script from "./OperationMenu.vue?vue&type=script&lang=js&"
export * from "./OperationMenu.vue?vue&type=script&lang=js&"
import style0 from "./OperationMenu.vue?vue&type=style&index=0&id=06c03b5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c03b5d",
  null
  
)

export default component.exports